import { axiosInstance } from '@/lib/axios';

/**
 * Contact Service
 * Handles contact form submission API calls
 */

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
  honeypot?: string; // Anti-spam honeypot field
}

export interface ContactSubmissionResponse {
  message: string;
}

/**
 * Submit contact form
 * Public endpoint - no authentication required
 */
export const submitContactForm = async (
  formData: ContactFormData
): Promise<ContactSubmissionResponse> => {
  const response = await axiosInstance.post<ContactSubmissionResponse>(
    '/contact/submit',
    formData
  );

  return response.data;
};
